import React,{useState,useEffect} from 'react';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import './Products.css'
import {useNavigate} from 'react-router-dom'
import {useProducts} from '../../store/ProductContext'
import { db } from '../../firebase/Config';
import { collection, addDoc , getDocs , query, where , updateDoc, doc} from 'firebase/firestore';
import { useUser } from '../../store/UserContext';
import LoadingForAll from '../../Pages/LoadingForAll';
import Category from '../Category/Category'
function Products() {
  const navigate=useNavigate()
   const {products ,loading, error  } = useProducts()
   const {currentUser}=useUser()
   const [category,setCategory]=useState('All-Products')
    useEffect(()=>{
       console.log(products)
     },[products])


     const [showAuthPopup, setShowAuthPopup] = useState(false)
     const [cartErr,setCartErr]=useState('')
     const [load,setLoad]=useState({})

     const handleAddToCart=async(product)=>{
      setLoad(prev=>({...prev, [product.id]:true}))
      try{
        if(!currentUser){
          setShowAuthPopup(true)  
          setLoad(prev => ({ ...prev, [product.id]: false }))
          return
        }

        const cartQuery=query(collection(db,'cart'),where('userId','==',currentUser.uid),where('productId','==',product.id))
        const cartSnapshot=await getDocs(cartQuery)
        if(!cartSnapshot.empty){
          const cartDoc=cartSnapshot.docs[0]
          const cartData=cartDoc.data()
          const newQuantity=cartData.quantity+1
          await updateDoc(doc(db,'cart',cartDoc.id),{quantity:newQuantity})
        }
        
        else{
        await addDoc(collection(db,'cart'),{
          userId:currentUser.uid,
          productId:product.id,
          productName:product.title,
          quantity:1,
          price:product.pricing.ourPrice,
          offer:product.pricing.offer,
          marketPrice:product.pricing.marketPrice,
          deliveryOption:product.deliveryOption,
          stock:product.stock,
          imageUrl:product.imageUrls?.imageUrl1
        })
      }
      
      }catch(err){
        setCartErr(err.message)
        setLoad(prev=>({...prev, [product.id]:false}))
      }finally{
        setLoad(prev=>({...prev, [product.id]:false}) )
      }

     }

     if (loading) return <div><LoadingForAll title='Loading products'/></div>;
     if (error) return <div>Error: {error}</div>;

  return (
    
    <div >

{showAuthPopup && (
        <div className="auth-popup-overlay">
          <div className="auth-popup">
            <h3>Login Required</h3>
            <p>You need to login to add items to your cart</p>
            <div className="auth-popup-buttons">
              <button 
                className="auth-popup-button login" 
                onClick={() => navigate('/login')}
              >
                Login
              </button>
              <button 
                className="auth-popup-button signup" 
                onClick={() => navigate('/signup')}
              >
                Sign Up
              </button>
              <button 
                className="auth-popup-button cancel" 
                onClick={() => setShowAuthPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <Category category={category} setCategory={setCategory}></Category>
      
         <div className="product-section" >
      <h2 className="section-title">{category}</h2>
      <div className="product-grid">
       {category==='All-Products' ? (
        products.map((product)=>(
        
          <div className="product-card ">
            
            <div className="product-image"  key={product.id} 
          onClick={()=>{navigate(`/view-product-details/${product.id}`) 
                        console.log('navigating to'+product.id)}}>
                          
              <img src={product.imageUrls?.imageUrl1} alt="iPhone 14 Pro" />
            </div>
            <div className="product-details">
              <h3 className="product-title">{product.title}</h3>
             
              <div className="product-price ">
                <span className="current-price">₹{product.pricing.ourPrice}</span>
                <span className="original-price">₹{product.pricing.marketPrice}</span> <br />
                <span className="discount">{product.pricing.offer}% off</span>
              </div>
              <div className="product-offers">
                
                <p>{product.deliveryOption} Delivery</p>
              </div>
              {product.stock == 0 ? (
              <button className="add-to-cart" disabled style={{backgroundColor:'#ccc',cursor:'not-allowed'}}>Product not available</button>
            ) : (
              <button className={`add-to-cart ${load[product.id] ? 'loadingProduct' : ''}`} onClick={() => {
                handleAddToCart(product)
              }}>{load[product.id] ? 'Adding...' : 'Add to Cart'}</button>
            )}
            {cartErr && <p className="error-message">{cartErr}</p>}
            </div>
          </div>
  
          
  
          
  ))
       ):(
        products.filter(product=>product.category === category).length > 0 ? (
          products.filter(product=>product.category === category).map((product)=>(
         
          <div className="product-card">
            
            <div className="product-image"  key={product.id} 
          onClick={()=>{navigate(`/view-product-details/${product.id}`) 
                        console.log('navigating to'+product.id)}}>
                          
              <img src={product.imageUrls?.imageUrl1} alt="iPhone 14 Pro" />
            </div>
            <div className="product-details">
              <h3 className="product-title">{product.title}</h3>
             
              <div className="product-price ">
                <span className="current-price">₹{product.pricing.ourPrice}</span>
                <span className="original-price">₹{product.pricing.marketPrice}</span> <br />
                <span className="discount">{product.pricing.offer}% off</span>
              </div>
              <div className="product-offers">
                
                <p>{product.deliveryOption} Delivery</p>
              </div>
              {product.stock == 0 ? (
              <button className="add-to-cart" disabled style={{backgroundColor:'#ccc',cursor:'not-allowed'}}>Product not available</button>
            ) : (
              <button className={`add-to-cart ${load[product.id] ? 'loadingProduct' : ''}`} onClick={() => {
                handleAddToCart(product)
              }}>{load[product.id] ? 'Adding...' : 'Add to Cart'}</button>
            )}
            {cartErr && <p className="error-message">{cartErr}</p>}
            </div>
          </div>
          
      
          ))
        ) : (
          <div className="no-products">
            <h2 >No {category} found </h2>
          </div>
        )
       )}
       
      </div>
    </div>
     
        
    </div>
  )
}

export default Products